/* tslint:disable */
/* eslint-disable */
/**
 * PRTIMES Media User API
 * メディアユーザーマイページ用 API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    BookmarkedPressReleasesResponse,
    BookmarkedPressReleasesResponseFromJSON,
    BookmarkedPressReleasesResponseToJSON,
    BookmarkedPressReleasesResponseV2,
    BookmarkedPressReleasesResponseV2FromJSON,
    BookmarkedPressReleasesResponseV2ToJSON,
    CompanyNameResponse,
    CompanyNameResponseFromJSON,
    CompanyNameResponseToJSON,
    DeleteBlockListByCompanyIdsRequestBody,
    DeleteBlockListByCompanyIdsRequestBodyFromJSON,
    DeleteBlockListByCompanyIdsRequestBodyToJSON,
    FetchBookmarkedPressReleasesRequest,
    FetchBookmarkedPressReleasesRequestFromJSON,
    FetchBookmarkedPressReleasesRequestToJSON,
    FetchHistoryPressReleasesRequest,
    FetchHistoryPressReleasesRequestFromJSON,
    FetchHistoryPressReleasesRequestToJSON,
    FollowingCompaniesResponse,
    FollowingCompaniesResponseFromJSON,
    FollowingCompaniesResponseToJSON,
    GetAccountSettingsResponse,
    GetAccountSettingsResponseFromJSON,
    GetAccountSettingsResponseToJSON,
    GetBlockedCompaniesResponse,
    GetBlockedCompaniesResponseFromJSON,
    GetBlockedCompaniesResponseToJSON,
    GetBusinessCategoiesResponse,
    GetBusinessCategoiesResponseFromJSON,
    GetBusinessCategoiesResponseToJSON,
    GetBusinessCategoriesLv2Response,
    GetBusinessCategoriesLv2ResponseFromJSON,
    GetBusinessCategoriesLv2ResponseToJSON,
    GetBusinessCategorySummaryResponse,
    GetBusinessCategorySummaryResponseFromJSON,
    GetBusinessCategorySummaryResponseToJSON,
    GetCompanyCategoriesResponse,
    GetCompanyCategoriesResponseFromJSON,
    GetCompanyCategoriesResponseToJSON,
    GetFollowingBusinessCategoriesLv2Response,
    GetFollowingBusinessCategoriesLv2ResponseFromJSON,
    GetFollowingBusinessCategoriesLv2ResponseToJSON,
    GetInitialSettingsCompletionResponse,
    GetInitialSettingsCompletionResponseFromJSON,
    GetInitialSettingsCompletionResponseToJSON,
    GetKeywordsResponse,
    GetKeywordsResponseFromJSON,
    GetKeywordsResponseToJSON,
    GetLocationsResponse,
    GetLocationsResponseFromJSON,
    GetLocationsResponseToJSON,
    GetMediaUserProfileResponse,
    GetMediaUserProfileResponseFromJSON,
    GetMediaUserProfileResponseToJSON,
    GetPrefecturesResponse,
    GetPrefecturesResponseFromJSON,
    GetPrefecturesResponseToJSON,
    GetPressReleaseTypesResponse,
    GetPressReleaseTypesResponseFromJSON,
    GetPressReleaseTypesResponseToJSON,
    GetRecommendPressReleasesResponse,
    GetRecommendPressReleasesResponseFromJSON,
    GetRecommendPressReleasesResponseToJSON,
    GetRegionsResponse,
    GetRegionsResponseFromJSON,
    GetRegionsResponseToJSON,
    GetSearchAutocompleteResponse,
    GetSearchAutocompleteResponseFromJSON,
    GetSearchAutocompleteResponseToJSON,
    GetSearchConditionsResponse,
    GetSearchConditionsResponseFromJSON,
    GetSearchConditionsResponseToJSON,
    GetSearchRecentQueriesResponse,
    GetSearchRecentQueriesResponseFromJSON,
    GetSearchRecentQueriesResponseToJSON,
    GetTutorialResponse,
    GetTutorialResponseFromJSON,
    GetTutorialResponseToJSON,
    HistoryPressReleasesResponse,
    HistoryPressReleasesResponseFromJSON,
    HistoryPressReleasesResponseToJSON,
    HistoryPressReleasesResponseV2,
    HistoryPressReleasesResponseV2FromJSON,
    HistoryPressReleasesResponseV2ToJSON,
    InlineObject,
    InlineObjectFromJSON,
    InlineObjectToJSON,
    InlineObject1,
    InlineObject1FromJSON,
    InlineObject1ToJSON,
    InlineObject2,
    InlineObject2FromJSON,
    InlineObject2ToJSON,
    LatestPressReleasesResponse,
    LatestPressReleasesResponseFromJSON,
    LatestPressReleasesResponseToJSON,
    LeaveRequestBody,
    LeaveRequestBodyFromJSON,
    LeaveRequestBodyToJSON,
    MeResponse,
    MeResponseFromJSON,
    MeResponseToJSON,
    MediaUserApiResponse,
    MediaUserApiResponseFromJSON,
    MediaUserApiResponseToJSON,
    PostAccountSettingsEmailV2Request,
    PostAccountSettingsEmailV2RequestFromJSON,
    PostAccountSettingsEmailV2RequestToJSON,
    PostAccountSettingsItem,
    PostAccountSettingsItemFromJSON,
    PostAccountSettingsItemToJSON,
    PostReceiveSettingsKeywordsResponse,
    PostReceiveSettingsKeywordsResponseFromJSON,
    PostReceiveSettingsKeywordsResponseToJSON,
    PostSearchCondition,
    PostSearchConditionFromJSON,
    PostSearchConditionToJSON,
    PostSearchRecentQueriesRequest,
    PostSearchRecentQueriesRequestFromJSON,
    PostSearchRecentQueriesRequestToJSON,
    ReceiveSettingsBulkUpdatePostRequest,
    ReceiveSettingsBulkUpdatePostRequestFromJSON,
    ReceiveSettingsBulkUpdatePostRequestToJSON,
    RecommendCompaniesResponse,
    RecommendCompaniesResponseFromJSON,
    RecommendCompaniesResponseToJSON,
    SearchFollowingPressReleaseRequest,
    SearchFollowingPressReleaseRequestFromJSON,
    SearchFollowingPressReleaseRequestToJSON,
    SearchFollowingPressReleaseResponse,
    SearchFollowingPressReleaseResponseFromJSON,
    SearchFollowingPressReleaseResponseToJSON,
    SearchLatestPressReleasesByBusinessCategoryLv2IdRequest,
    SearchLatestPressReleasesByBusinessCategoryLv2IdRequestFromJSON,
    SearchLatestPressReleasesByBusinessCategoryLv2IdRequestToJSON,
    SearchLatestPressReleasesByBusinessCategoryLv2IdResponse,
    SearchLatestPressReleasesByBusinessCategoryLv2IdResponseFromJSON,
    SearchLatestPressReleasesByBusinessCategoryLv2IdResponseToJSON,
    SearchLatestPressReleasesRequest,
    SearchLatestPressReleasesRequestFromJSON,
    SearchLatestPressReleasesRequestToJSON,
    SearchLatestPressReleasesResponse,
    SearchLatestPressReleasesResponseFromJSON,
    SearchLatestPressReleasesResponseToJSON,
    SearchPublishedDateOrderPressReleaseRequest,
    SearchPublishedDateOrderPressReleaseRequestFromJSON,
    SearchPublishedDateOrderPressReleaseRequestToJSON,
    SearchPublishedDateOrderPressReleaseResponse,
    SearchPublishedDateOrderPressReleaseResponseFromJSON,
    SearchPublishedDateOrderPressReleaseResponseToJSON,
    SearchRelevanceScoreOrderPressReleaseRequest,
    SearchRelevanceScoreOrderPressReleaseRequestFromJSON,
    SearchRelevanceScoreOrderPressReleaseRequestToJSON,
    SearchRelevanceScoreOrderPressReleaseResponse,
    SearchRelevanceScoreOrderPressReleaseResponseFromJSON,
    SearchRelevanceScoreOrderPressReleaseResponseToJSON,
    SearchedCompaniesResponse,
    SearchedCompaniesResponseFromJSON,
    SearchedCompaniesResponseToJSON,
    SearchedPressReleasesResponse,
    SearchedPressReleasesResponseFromJSON,
    SearchedPressReleasesResponseToJSON,
    SignInApiResponse,
    SignInApiResponseFromJSON,
    SignInApiResponseToJSON,
    SignInRequestBody,
    SignInRequestBodyFromJSON,
    SignInRequestBodyToJSON,
    TutorialStep,
    TutorialStepFromJSON,
    TutorialStepToJSON,
    ValidetaionErrorResponse,
    ValidetaionErrorResponseFromJSON,
    ValidetaionErrorResponseToJSON,
} from '../models';

export interface BlockCompanyRequest {
    companyId: number;
}

export interface BookmarkPressReleaseRequest {
    pressReleaseId: number;
    companyId: number;
}

export interface CompanyNameRequest {
    companyId: number;
}

export interface CompleteTutorialRequest {
    tutorialStep: TutorialStep;
}

export interface DeleteBlockListByCompanyIdsRequest {
    deleteBlockListByCompanyIdsRequestBody?: DeleteBlockListByCompanyIdsRequestBody;
}

export interface DeleteCompaniesCompanyIdBlockRequest {
    companyId: number;
}

export interface DeleteMeSearchConditionRequest {
    id: number;
}

export interface DeleteReceiveSettingsBusinessCategoriesRequest {
    categoryId: string;
    categoryLv2Id: number;
}

export interface DeleteReceiveSettingsCitiesRequest {
    prefectureId: string;
    cityId: string;
}

export interface DeleteReceiveSettingsCompanyCategoriesRequest {
    categoryId: string;
}

export interface DeleteReceiveSettingsKeywordsRequest {
    id: string;
}

export interface DeleteReceiveSettingsPrefecturesRequest {
    prefectureId: string;
}

export interface DeleteReceiveSettingsPressReleaseTypesRequest {
    typeId: string;
}

export interface FetchBookmarkedPressReleasesOperationRequest {
    fetchBookmarkedPressReleasesRequest?: FetchBookmarkedPressReleasesRequest;
}

export interface FetchHistoryPressReleasesOperationRequest {
    fetchHistoryPressReleasesRequest?: FetchHistoryPressReleasesRequest;
}

export interface GetBookmarkedPressReleasesRequest {
    cursor?: string;
    limit?: number;
}

export interface GetBusinessCategoryLv2SummaryRequest {
    businessCategoryLv2Id: number;
}

export interface GetCompaniesBlocksRequest {
    cursor?: string;
    limit?: number;
}

export interface GetFollowingCompaniesRequest {
    cursor?: string;
    limit?: number;
}

export interface GetHistoryPressReleasesRequest {
    cursor?: string;
    limit?: number;
}

export interface GetLatestPressReleasesResponseRequest {
    cursor?: string;
    limit?: number;
}

export interface GetRecommendPressReleasesByMediaUserIdRequest {
    mediaUserId: number;
}

export interface GetSearchAutocompleteRequest {
    searchKeyword: string;
}

export interface GetSearchRecentQueriesRequest {
    limit?: number;
}

export interface GetTutorialRequest {
    tutorialStep: TutorialStep;
}

export interface PostAccountSettingsRequest {
    postAccountSettingsItem?: PostAccountSettingsItem;
}

export interface PostAccountSettingsEmailRequest {
    inlineObject1?: InlineObject1;
}

export interface PostAccountSettingsEmailV2OperationRequest {
    postAccountSettingsEmailV2Request?: PostAccountSettingsEmailV2Request;
}

export interface PostAccountSettingsPasswordRequest {
    inlineObject2?: InlineObject2;
}

export interface PostLeaveRequest {
    leaveRequestBody?: LeaveRequestBody;
}

export interface PostMeSearchConditionRequest {
    postSearchCondition?: PostSearchCondition;
}

export interface PostReceiveSettingsBulkUpdateRequest {
    receiveSettingsBulkUpdatePostRequest?: ReceiveSettingsBulkUpdatePostRequest;
}

export interface PostReceiveSettingsBusinessCategoriesRequest {
    categoryId: string;
    categoryLv2Id: number;
}

export interface PostReceiveSettingsCitiesRequest {
    prefectureId: string;
    cityId: string;
}

export interface PostReceiveSettingsCompanyCategoriesRequest {
    categoryId: string;
}

export interface PostReceiveSettingsKeywordsRequest {
    inlineObject?: InlineObject;
}

export interface PostReceiveSettingsPrefecturesRequest {
    prefectureId: string;
}

export interface PostReceiveSettingsPressReleaseTypesRequest {
    typeId: string;
}

export interface PostSearchRecentQueriesOperationRequest {
    postSearchRecentQueriesRequest?: PostSearchRecentQueriesRequest;
}

export interface PostSignInRequest {
    signInRequestBody?: SignInRequestBody;
}

export interface SearchCompaniesRequest {
    keyword: string;
    cursor?: string;
    limit?: number;
}

export interface SearchFollowingPressReleasesRequest {
    searchFollowingPressReleaseRequest?: SearchFollowingPressReleaseRequest;
}

export interface SearchLatestPressReleasesOperationRequest {
    searchLatestPressReleasesRequest?: SearchLatestPressReleasesRequest;
}

export interface SearchLatestPressReleasesByBusinessCategoryLv2IdOperationRequest {
    businessCategoryLv2Id: number;
    searchLatestPressReleasesByBusinessCategoryLv2IdRequest?: SearchLatestPressReleasesByBusinessCategoryLv2IdRequest;
}

export interface SearchPressReleasesRequest {
    keyword: string;
    cursor?: string;
    limit?: number;
}

export interface SearchPressReleasesOrderByPublishedDateRequest {
    searchPublishedDateOrderPressReleaseRequest?: SearchPublishedDateOrderPressReleaseRequest;
}

export interface SearchPressReleasesOrderByRelevanceScoreRequest {
    searchRelevanceScoreOrderPressReleaseRequest?: SearchRelevanceScoreOrderPressReleaseRequest;
}

export interface UnbookmarkPressReleaseRequest {
    pressReleaseId: number;
    companyId: number;
}

/**
 * 
 */
export class MediaUserApi extends runtime.BaseAPI {

    /**
     * プレスリリース一覧から非表示にする
     * 企業をブロック
     */
    async blockCompanyRaw(requestParameters: BlockCompanyRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<MediaUserApiResponse>> {
        if (requestParameters.companyId === null || requestParameters.companyId === undefined) {
            throw new runtime.RequiredError('companyId','Required parameter requestParameters.companyId was null or undefined when calling blockCompany.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/companies/{company_id}/block`.replace(`{${"company_id"}}`, encodeURIComponent(String(requestParameters.companyId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MediaUserApiResponseFromJSON(jsonValue));
    }

    /**
     * プレスリリース一覧から非表示にする
     * 企業をブロック
     */
    async blockCompany(requestParameters: BlockCompanyRequest, initOverrides?: RequestInit): Promise<MediaUserApiResponse> {
        const response = await this.blockCompanyRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 指定されたプレスリリースを保存（ブックマーク）する
     * プレスリリースを保存
     */
    async bookmarkPressReleaseRaw(requestParameters: BookmarkPressReleaseRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<MediaUserApiResponse>> {
        if (requestParameters.pressReleaseId === null || requestParameters.pressReleaseId === undefined) {
            throw new runtime.RequiredError('pressReleaseId','Required parameter requestParameters.pressReleaseId was null or undefined when calling bookmarkPressRelease.');
        }

        if (requestParameters.companyId === null || requestParameters.companyId === undefined) {
            throw new runtime.RequiredError('companyId','Required parameter requestParameters.companyId was null or undefined when calling bookmarkPressRelease.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/press_releases/{press_release_id}.{company_id}/bookmark`.replace(`{${"press_release_id"}}`, encodeURIComponent(String(requestParameters.pressReleaseId))).replace(`{${"company_id"}}`, encodeURIComponent(String(requestParameters.companyId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MediaUserApiResponseFromJSON(jsonValue));
    }

    /**
     * 指定されたプレスリリースを保存（ブックマーク）する
     * プレスリリースを保存
     */
    async bookmarkPressRelease(requestParameters: BookmarkPressReleaseRequest, initOverrides?: RequestInit): Promise<MediaUserApiResponse> {
        const response = await this.bookmarkPressReleaseRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 企業名を取得する
     * 企業名を取得する
     */
    async companyNameRaw(requestParameters: CompanyNameRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<CompanyNameResponse>> {
        if (requestParameters.companyId === null || requestParameters.companyId === undefined) {
            throw new runtime.RequiredError('companyId','Required parameter requestParameters.companyId was null or undefined when calling companyName.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/companies/{company_id}/name`.replace(`{${"company_id"}}`, encodeURIComponent(String(requestParameters.companyId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CompanyNameResponseFromJSON(jsonValue));
    }

    /**
     * 企業名を取得する
     * 企業名を取得する
     */
    async companyName(requestParameters: CompanyNameRequest, initOverrides?: RequestInit): Promise<CompanyNameResponse> {
        const response = await this.companyNameRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 特定のチュートリアルを完了状態にするAPI
     * 特定のチュートリアルを完了状態にするAPI
     */
    async completeTutorialRaw(requestParameters: CompleteTutorialRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<MediaUserApiResponse>> {
        if (requestParameters.tutorialStep === null || requestParameters.tutorialStep === undefined) {
            throw new runtime.RequiredError('tutorialStep','Required parameter requestParameters.tutorialStep was null or undefined when calling completeTutorial.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/tutorials/{tutorial_step}`.replace(`{${"tutorial_step"}}`, encodeURIComponent(String(requestParameters.tutorialStep))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MediaUserApiResponseFromJSON(jsonValue));
    }

    /**
     * 特定のチュートリアルを完了状態にするAPI
     * 特定のチュートリアルを完了状態にするAPI
     */
    async completeTutorial(requestParameters: CompleteTutorialRequest, initOverrides?: RequestInit): Promise<MediaUserApiResponse> {
        const response = await this.completeTutorialRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * メディアユーザーが選択した企業を除外リストから削除する
     * メディアユーザーが選択した企業を除外リストから削除する
     */
    async deleteBlockListByCompanyIdsRaw(requestParameters: DeleteBlockListByCompanyIdsRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<MediaUserApiResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/companies/blocks/selected`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: DeleteBlockListByCompanyIdsRequestBodyToJSON(requestParameters.deleteBlockListByCompanyIdsRequestBody),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MediaUserApiResponseFromJSON(jsonValue));
    }

    /**
     * メディアユーザーが選択した企業を除外リストから削除する
     * メディアユーザーが選択した企業を除外リストから削除する
     */
    async deleteBlockListByCompanyIds(requestParameters: DeleteBlockListByCompanyIdsRequest = {}, initOverrides?: RequestInit): Promise<MediaUserApiResponse> {
        const response = await this.deleteBlockListByCompanyIdsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ブロックした企業を一括で解除する
     * ブロックした企業を一括で解除する
     */
    async deleteCompaniesBlocksRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<MediaUserApiResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/companies/blocks`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MediaUserApiResponseFromJSON(jsonValue));
    }

    /**
     * ブロックした企業を一括で解除する
     * ブロックした企業を一括で解除する
     */
    async deleteCompaniesBlocks(initOverrides?: RequestInit): Promise<MediaUserApiResponse> {
        const response = await this.deleteCompaniesBlocksRaw(initOverrides);
        return await response.value();
    }

    /**
     * 除外している企業を解除する
     * ブロックした企業を解除する
     */
    async deleteCompaniesCompanyIdBlockRaw(requestParameters: DeleteCompaniesCompanyIdBlockRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<MediaUserApiResponse>> {
        if (requestParameters.companyId === null || requestParameters.companyId === undefined) {
            throw new runtime.RequiredError('companyId','Required parameter requestParameters.companyId was null or undefined when calling deleteCompaniesCompanyIdBlock.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/companies/{company_id}/block`.replace(`{${"company_id"}}`, encodeURIComponent(String(requestParameters.companyId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MediaUserApiResponseFromJSON(jsonValue));
    }

    /**
     * 除外している企業を解除する
     * ブロックした企業を解除する
     */
    async deleteCompaniesCompanyIdBlock(requestParameters: DeleteCompaniesCompanyIdBlockRequest, initOverrides?: RequestInit): Promise<MediaUserApiResponse> {
        const response = await this.deleteCompaniesCompanyIdBlockRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 検索条件を削除するAPI
     * 検索条件を削除するAPI
     */
    async deleteMeSearchConditionRaw(requestParameters: DeleteMeSearchConditionRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<MediaUserApiResponse>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling deleteMeSearchCondition.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/me/search_conditions/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MediaUserApiResponseFromJSON(jsonValue));
    }

    /**
     * 検索条件を削除するAPI
     * 検索条件を削除するAPI
     */
    async deleteMeSearchCondition(requestParameters: DeleteMeSearchConditionRequest, initOverrides?: RequestInit): Promise<MediaUserApiResponse> {
        const response = await this.deleteMeSearchConditionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 特定のビジネスカテゴリの受信設定を削除するAPI
     * 特定のビジネスカテゴリの受信設定を削除するAPI
     */
    async deleteReceiveSettingsBusinessCategoriesRaw(requestParameters: DeleteReceiveSettingsBusinessCategoriesRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<MediaUserApiResponse>> {
        if (requestParameters.categoryId === null || requestParameters.categoryId === undefined) {
            throw new runtime.RequiredError('categoryId','Required parameter requestParameters.categoryId was null or undefined when calling deleteReceiveSettingsBusinessCategories.');
        }

        if (requestParameters.categoryLv2Id === null || requestParameters.categoryLv2Id === undefined) {
            throw new runtime.RequiredError('categoryLv2Id','Required parameter requestParameters.categoryLv2Id was null or undefined when calling deleteReceiveSettingsBusinessCategories.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/receive_settings/business_categories/{category_id}/{category_lv2_id}`.replace(`{${"category_id"}}`, encodeURIComponent(String(requestParameters.categoryId))).replace(`{${"category_lv2_id"}}`, encodeURIComponent(String(requestParameters.categoryLv2Id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MediaUserApiResponseFromJSON(jsonValue));
    }

    /**
     * 特定のビジネスカテゴリの受信設定を削除するAPI
     * 特定のビジネスカテゴリの受信設定を削除するAPI
     */
    async deleteReceiveSettingsBusinessCategories(requestParameters: DeleteReceiveSettingsBusinessCategoriesRequest, initOverrides?: RequestInit): Promise<MediaUserApiResponse> {
        const response = await this.deleteReceiveSettingsBusinessCategoriesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 特定の市区町村の受信設定を削除するAPI
     * 特定の市区町村の受信設定を削除するAPI
     */
    async deleteReceiveSettingsCitiesRaw(requestParameters: DeleteReceiveSettingsCitiesRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<MediaUserApiResponse>> {
        if (requestParameters.prefectureId === null || requestParameters.prefectureId === undefined) {
            throw new runtime.RequiredError('prefectureId','Required parameter requestParameters.prefectureId was null or undefined when calling deleteReceiveSettingsCities.');
        }

        if (requestParameters.cityId === null || requestParameters.cityId === undefined) {
            throw new runtime.RequiredError('cityId','Required parameter requestParameters.cityId was null or undefined when calling deleteReceiveSettingsCities.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/receive_settings/locations/{prefecture_id}/{city_id}`.replace(`{${"prefecture_id"}}`, encodeURIComponent(String(requestParameters.prefectureId))).replace(`{${"city_id"}}`, encodeURIComponent(String(requestParameters.cityId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MediaUserApiResponseFromJSON(jsonValue));
    }

    /**
     * 特定の市区町村の受信設定を削除するAPI
     * 特定の市区町村の受信設定を削除するAPI
     */
    async deleteReceiveSettingsCities(requestParameters: DeleteReceiveSettingsCitiesRequest, initOverrides?: RequestInit): Promise<MediaUserApiResponse> {
        const response = await this.deleteReceiveSettingsCitiesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 特定の企業カテゴリの受信設定を削除するAPI
     * 特定の企業カテゴリの受信設定を削除するAPI
     */
    async deleteReceiveSettingsCompanyCategoriesRaw(requestParameters: DeleteReceiveSettingsCompanyCategoriesRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<MediaUserApiResponse>> {
        if (requestParameters.categoryId === null || requestParameters.categoryId === undefined) {
            throw new runtime.RequiredError('categoryId','Required parameter requestParameters.categoryId was null or undefined when calling deleteReceiveSettingsCompanyCategories.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/receive_settings/company_categories/{category_id}`.replace(`{${"category_id"}}`, encodeURIComponent(String(requestParameters.categoryId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MediaUserApiResponseFromJSON(jsonValue));
    }

    /**
     * 特定の企業カテゴリの受信設定を削除するAPI
     * 特定の企業カテゴリの受信設定を削除するAPI
     */
    async deleteReceiveSettingsCompanyCategories(requestParameters: DeleteReceiveSettingsCompanyCategoriesRequest, initOverrides?: RequestInit): Promise<MediaUserApiResponse> {
        const response = await this.deleteReceiveSettingsCompanyCategoriesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 特定のキーワードの受信設定を追加するAPI
     * 特定のキーワードの受信設定を削除するAPI
     */
    async deleteReceiveSettingsKeywordsRaw(requestParameters: DeleteReceiveSettingsKeywordsRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<MediaUserApiResponse>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling deleteReceiveSettingsKeywords.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/receive_settings/keywords/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MediaUserApiResponseFromJSON(jsonValue));
    }

    /**
     * 特定のキーワードの受信設定を追加するAPI
     * 特定のキーワードの受信設定を削除するAPI
     */
    async deleteReceiveSettingsKeywords(requestParameters: DeleteReceiveSettingsKeywordsRequest, initOverrides?: RequestInit): Promise<MediaUserApiResponse> {
        const response = await this.deleteReceiveSettingsKeywordsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 特定の都道府県の受信設定を削除するAPI
     * 特定の都道府県の受信設定を削除するAPI
     */
    async deleteReceiveSettingsPrefecturesRaw(requestParameters: DeleteReceiveSettingsPrefecturesRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<MediaUserApiResponse>> {
        if (requestParameters.prefectureId === null || requestParameters.prefectureId === undefined) {
            throw new runtime.RequiredError('prefectureId','Required parameter requestParameters.prefectureId was null or undefined when calling deleteReceiveSettingsPrefectures.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/receive_settings/locations/{prefecture_id}`.replace(`{${"prefecture_id"}}`, encodeURIComponent(String(requestParameters.prefectureId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MediaUserApiResponseFromJSON(jsonValue));
    }

    /**
     * 特定の都道府県の受信設定を削除するAPI
     * 特定の都道府県の受信設定を削除するAPI
     */
    async deleteReceiveSettingsPrefectures(requestParameters: DeleteReceiveSettingsPrefecturesRequest, initOverrides?: RequestInit): Promise<MediaUserApiResponse> {
        const response = await this.deleteReceiveSettingsPrefecturesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 特定のプレスリリース種類の受信設定を削除するAPI
     * 特定のプレスリリース種類の受信設定を削除するAPI
     */
    async deleteReceiveSettingsPressReleaseTypesRaw(requestParameters: DeleteReceiveSettingsPressReleaseTypesRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<MediaUserApiResponse>> {
        if (requestParameters.typeId === null || requestParameters.typeId === undefined) {
            throw new runtime.RequiredError('typeId','Required parameter requestParameters.typeId was null or undefined when calling deleteReceiveSettingsPressReleaseTypes.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/receive_settings/press_release_types/{type_id}`.replace(`{${"type_id"}}`, encodeURIComponent(String(requestParameters.typeId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MediaUserApiResponseFromJSON(jsonValue));
    }

    /**
     * 特定のプレスリリース種類の受信設定を削除するAPI
     * 特定のプレスリリース種類の受信設定を削除するAPI
     */
    async deleteReceiveSettingsPressReleaseTypes(requestParameters: DeleteReceiveSettingsPressReleaseTypesRequest, initOverrides?: RequestInit): Promise<MediaUserApiResponse> {
        const response = await this.deleteReceiveSettingsPressReleaseTypesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * メディアユーザーの保存済みプレスリリースの一覧を取得するAPI。 新UI上で、絞り込み用のパラメーターが追加されるため、GETでリクエストを送るとURLが長くなってしまう。避けるために、POSTでリクエストを送るようにする。
     * 保存済みプレスリリースの一覧を取得するAPI（新UI用）
     */
    async fetchBookmarkedPressReleasesRaw(requestParameters: FetchBookmarkedPressReleasesOperationRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<BookmarkedPressReleasesResponseV2>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/press_releases/bookmarks`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FetchBookmarkedPressReleasesRequestToJSON(requestParameters.fetchBookmarkedPressReleasesRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BookmarkedPressReleasesResponseV2FromJSON(jsonValue));
    }

    /**
     * メディアユーザーの保存済みプレスリリースの一覧を取得するAPI。 新UI上で、絞り込み用のパラメーターが追加されるため、GETでリクエストを送るとURLが長くなってしまう。避けるために、POSTでリクエストを送るようにする。
     * 保存済みプレスリリースの一覧を取得するAPI（新UI用）
     */
    async fetchBookmarkedPressReleases(requestParameters: FetchBookmarkedPressReleasesOperationRequest = {}, initOverrides?: RequestInit): Promise<BookmarkedPressReleasesResponseV2> {
        const response = await this.fetchBookmarkedPressReleasesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * メディアユーザーの閲覧履歴の一覧を取得するAPI。 新UI上で、絞り込み用のパラメーターが追加されるため、GETでリクエストを送るとURLが長くなってしまう。避けるために、POSTでリクエストを送るようにする。
     * 今までに閲覧したプレスリリースの一覧を取得する（新UI用）
     */
    async fetchHistoryPressReleasesRaw(requestParameters: FetchHistoryPressReleasesOperationRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<HistoryPressReleasesResponseV2>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/press_releases/history`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FetchHistoryPressReleasesRequestToJSON(requestParameters.fetchHistoryPressReleasesRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => HistoryPressReleasesResponseV2FromJSON(jsonValue));
    }

    /**
     * メディアユーザーの閲覧履歴の一覧を取得するAPI。 新UI上で、絞り込み用のパラメーターが追加されるため、GETでリクエストを送るとURLが長くなってしまう。避けるために、POSTでリクエストを送るようにする。
     * 今までに閲覧したプレスリリースの一覧を取得する（新UI用）
     */
    async fetchHistoryPressReleases(requestParameters: FetchHistoryPressReleasesOperationRequest = {}, initOverrides?: RequestInit): Promise<HistoryPressReleasesResponseV2> {
        const response = await this.fetchHistoryPressReleasesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * メディアユーザーアカウント設定情報取得API
     * メディアユーザーアカウント設定情報取得API
     */
    async getAccountSettingsRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<GetAccountSettingsResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/account_settings`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetAccountSettingsResponseFromJSON(jsonValue));
    }

    /**
     * メディアユーザーアカウント設定情報取得API
     * メディアユーザーアカウント設定情報取得API
     */
    async getAccountSettings(initOverrides?: RequestInit): Promise<GetAccountSettingsResponse> {
        const response = await this.getAccountSettingsRaw(initOverrides);
        return await response.value();
    }

    /**
     * 保存されたプレスリリースの一覧を取得する
     * 保存されたプレスリリースの一覧を取得する
     */
    async getBookmarkedPressReleasesRaw(requestParameters: GetBookmarkedPressReleasesRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<BookmarkedPressReleasesResponse>> {
        const queryParameters: any = {};

        if (requestParameters.cursor !== undefined) {
            queryParameters['cursor'] = requestParameters.cursor;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/press_releases/bookmarks`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BookmarkedPressReleasesResponseFromJSON(jsonValue));
    }

    /**
     * 保存されたプレスリリースの一覧を取得する
     * 保存されたプレスリリースの一覧を取得する
     */
    async getBookmarkedPressReleases(requestParameters: GetBookmarkedPressReleasesRequest = {}, initOverrides?: RequestInit): Promise<BookmarkedPressReleasesResponse> {
        const response = await this.getBookmarkedPressReleasesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ビジネスカテゴリ覧取得API
     * ビジネスカテゴリ覧取得API
     */
    async getBusinessCategoriesLv2Raw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<GetBusinessCategoriesLv2Response>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/business_categories_lv2`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetBusinessCategoriesLv2ResponseFromJSON(jsonValue));
    }

    /**
     * ビジネスカテゴリ覧取得API
     * ビジネスカテゴリ覧取得API
     */
    async getBusinessCategoriesLv2(initOverrides?: RequestInit): Promise<GetBusinessCategoriesLv2Response> {
        const response = await this.getBusinessCategoriesLv2Raw(initOverrides);
        return await response.value();
    }

    /**
     * ビジネスカテゴリで配信されたプレスリリース数、フォロー数、ビジネスカテゴリをフォローしているかどうかを返すAPI
     * ビジネスカテゴリの概要を返すAPI
     */
    async getBusinessCategoryLv2SummaryRaw(requestParameters: GetBusinessCategoryLv2SummaryRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<GetBusinessCategorySummaryResponse>> {
        if (requestParameters.businessCategoryLv2Id === null || requestParameters.businessCategoryLv2Id === undefined) {
            throw new runtime.RequiredError('businessCategoryLv2Id','Required parameter requestParameters.businessCategoryLv2Id was null or undefined when calling getBusinessCategoryLv2Summary.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/business_categories_lv2/{business_category_lv2_id}`.replace(`{${"business_category_lv2_id"}}`, encodeURIComponent(String(requestParameters.businessCategoryLv2Id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetBusinessCategorySummaryResponseFromJSON(jsonValue));
    }

    /**
     * ビジネスカテゴリで配信されたプレスリリース数、フォロー数、ビジネスカテゴリをフォローしているかどうかを返すAPI
     * ビジネスカテゴリの概要を返すAPI
     */
    async getBusinessCategoryLv2Summary(requestParameters: GetBusinessCategoryLv2SummaryRequest, initOverrides?: RequestInit): Promise<GetBusinessCategorySummaryResponse> {
        const response = await this.getBusinessCategoryLv2SummaryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ブロックした企業一覧を取得
     * ブロックした企業一覧を取得
     */
    async getCompaniesBlocksRaw(requestParameters: GetCompaniesBlocksRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<GetBlockedCompaniesResponse>> {
        const queryParameters: any = {};

        if (requestParameters.cursor !== undefined) {
            queryParameters['cursor'] = requestParameters.cursor;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/companies/blocks`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetBlockedCompaniesResponseFromJSON(jsonValue));
    }

    /**
     * ブロックした企業一覧を取得
     * ブロックした企業一覧を取得
     */
    async getCompaniesBlocks(requestParameters: GetCompaniesBlocksRequest = {}, initOverrides?: RequestInit): Promise<GetBlockedCompaniesResponse> {
        const response = await this.getCompaniesBlocksRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * フォロー中のビジネスカテゴリを取得するAPI
     * Get business_categories you follow
     */
    async getFollowingBusinessCategoriesLv2Raw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<GetFollowingBusinessCategoriesLv2Response>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/me/following/business_categories_lv2`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetFollowingBusinessCategoriesLv2ResponseFromJSON(jsonValue));
    }

    /**
     * フォロー中のビジネスカテゴリを取得するAPI
     * Get business_categories you follow
     */
    async getFollowingBusinessCategoriesLv2(initOverrides?: RequestInit): Promise<GetFollowingBusinessCategoriesLv2Response> {
        const response = await this.getFollowingBusinessCategoriesLv2Raw(initOverrides);
        return await response.value();
    }

    /**
     * フォロー中の企業一覧を取得
     * フォロー中の企業一覧を取得する
     */
    async getFollowingCompaniesRaw(requestParameters: GetFollowingCompaniesRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<FollowingCompaniesResponse>> {
        const queryParameters: any = {};

        if (requestParameters.cursor !== undefined) {
            queryParameters['cursor'] = requestParameters.cursor;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/companies/followings`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FollowingCompaniesResponseFromJSON(jsonValue));
    }

    /**
     * フォロー中の企業一覧を取得
     * フォロー中の企業一覧を取得する
     */
    async getFollowingCompanies(requestParameters: GetFollowingCompaniesRequest = {}, initOverrides?: RequestInit): Promise<FollowingCompaniesResponse> {
        const response = await this.getFollowingCompaniesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 今までに閲覧したプレスリリースの一覧を取得する
     * 今までに閲覧したプレスリリースの一覧を取得する
     */
    async getHistoryPressReleasesRaw(requestParameters: GetHistoryPressReleasesRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<HistoryPressReleasesResponse>> {
        const queryParameters: any = {};

        if (requestParameters.cursor !== undefined) {
            queryParameters['cursor'] = requestParameters.cursor;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/press_releases/history`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => HistoryPressReleasesResponseFromJSON(jsonValue));
    }

    /**
     * 今までに閲覧したプレスリリースの一覧を取得する
     * 今までに閲覧したプレスリリースの一覧を取得する
     */
    async getHistoryPressReleases(requestParameters: GetHistoryPressReleasesRequest = {}, initOverrides?: RequestInit): Promise<HistoryPressReleasesResponse> {
        const response = await this.getHistoryPressReleasesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 初期設定が完了しているかを取得するAPI
     * 初期設定が完了しているかを取得するAPI
     */
    async getInitialSettingsCompletionRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<GetInitialSettingsCompletionResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/initial_settings_completion`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetInitialSettingsCompletionResponseFromJSON(jsonValue));
    }

    /**
     * 初期設定が完了しているかを取得するAPI
     * 初期設定が完了しているかを取得するAPI
     */
    async getInitialSettingsCompletion(initOverrides?: RequestInit): Promise<GetInitialSettingsCompletionResponse> {
        const response = await this.getInitialSettingsCompletionRaw(initOverrides);
        return await response.value();
    }

    /**
     * プレスリリース受信設定に基づいて最新プレスリリースを取得
     * 最新プレスリリースを取得する
     */
    async getLatestPressReleasesResponseRaw(requestParameters: GetLatestPressReleasesResponseRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<LatestPressReleasesResponse>> {
        const queryParameters: any = {};

        if (requestParameters.cursor !== undefined) {
            queryParameters['cursor'] = requestParameters.cursor;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/press_releases`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LatestPressReleasesResponseFromJSON(jsonValue));
    }

    /**
     * プレスリリース受信設定に基づいて最新プレスリリースを取得
     * 最新プレスリリースを取得する
     */
    async getLatestPressReleasesResponse(requestParameters: GetLatestPressReleasesResponseRequest = {}, initOverrides?: RequestInit): Promise<LatestPressReleasesResponse> {
        const response = await this.getLatestPressReleasesResponseRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ログイン中メディアユーザーの名前を取得
     * メディアユーザーの名取得
     */
    async getMeRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<MeResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/me`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MeResponseFromJSON(jsonValue));
    }

    /**
     * ログイン中メディアユーザーの名前を取得
     * メディアユーザーの名取得
     */
    async getMe(initOverrides?: RequestInit): Promise<MeResponse> {
        const response = await this.getMeRaw(initOverrides);
        return await response.value();
    }

    /**
     * 保存した検索条件を取得するAPI
     * 保存した検索条件を取得するAPI
     */
    async getMeSearchConditionsRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<GetSearchConditionsResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/me/search_conditions`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetSearchConditionsResponseFromJSON(jsonValue));
    }

    /**
     * 保存した検索条件を取得するAPI
     * 保存した検索条件を取得するAPI
     */
    async getMeSearchConditions(initOverrides?: RequestInit): Promise<GetSearchConditionsResponse> {
        const response = await this.getMeSearchConditionsRaw(initOverrides);
        return await response.value();
    }

    /**
     * 位置情報一覧取得API
     * 位置情報一覧取得API
     */
    async getPrefecturesRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<GetPrefecturesResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/prefectures`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetPrefecturesResponseFromJSON(jsonValue));
    }

    /**
     * 位置情報一覧取得API
     * 位置情報一覧取得API
     */
    async getPrefectures(initOverrides?: RequestInit): Promise<GetPrefecturesResponse> {
        const response = await this.getPrefecturesRaw(initOverrides);
        return await response.value();
    }

    /**
     * メディアユーザーのプロフィールを取得。【プロフィール】ページ用
     * メディアユーザーのプロフィールを取得
     */
    async getProfileRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<GetMediaUserProfileResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/profile`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetMediaUserProfileResponseFromJSON(jsonValue));
    }

    /**
     * メディアユーザーのプロフィールを取得。【プロフィール】ページ用
     * メディアユーザーのプロフィールを取得
     */
    async getProfile(initOverrides?: RequestInit): Promise<GetMediaUserProfileResponse> {
        const response = await this.getProfileRaw(initOverrides);
        return await response.value();
    }

    /**
     * ビジネスカテゴリ一覧取得API
     * ビジネスカテゴリ一覧取得API
     */
    async getReceiveSettingsBusinessCategoriesRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<GetBusinessCategoiesResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/receive_settings/business_categories`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetBusinessCategoiesResponseFromJSON(jsonValue));
    }

    /**
     * ビジネスカテゴリ一覧取得API
     * ビジネスカテゴリ一覧取得API
     */
    async getReceiveSettingsBusinessCategories(initOverrides?: RequestInit): Promise<GetBusinessCategoiesResponse> {
        const response = await this.getReceiveSettingsBusinessCategoriesRaw(initOverrides);
        return await response.value();
    }

    /**
     * 企業カテゴリ一覧取得API
     * 企業カテゴリ一覧取得API
     */
    async getReceiveSettingsCompanyCategoriesRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<GetCompanyCategoriesResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/receive_settings/company_categories`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetCompanyCategoriesResponseFromJSON(jsonValue));
    }

    /**
     * 企業カテゴリ一覧取得API
     * 企業カテゴリ一覧取得API
     */
    async getReceiveSettingsCompanyCategories(initOverrides?: RequestInit): Promise<GetCompanyCategoriesResponse> {
        const response = await this.getReceiveSettingsCompanyCategoriesRaw(initOverrides);
        return await response.value();
    }

    /**
     * 登録済みキーワード一覧取得API
     * 登録済みキーワード一覧取得API
     */
    async getReceiveSettingsKeywordsRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<GetKeywordsResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/receive_settings/keywords`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetKeywordsResponseFromJSON(jsonValue));
    }

    /**
     * 登録済みキーワード一覧取得API
     * 登録済みキーワード一覧取得API
     */
    async getReceiveSettingsKeywords(initOverrides?: RequestInit): Promise<GetKeywordsResponse> {
        const response = await this.getReceiveSettingsKeywordsRaw(initOverrides);
        return await response.value();
    }

    /**
     * 登録済み位置情報一覧取得API
     * 登録済み位置情報一覧取得API
     */
    async getReceiveSettingsLocationsRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<GetLocationsResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/receive_settings/locations`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetLocationsResponseFromJSON(jsonValue));
    }

    /**
     * 登録済み位置情報一覧取得API
     * 登録済み位置情報一覧取得API
     */
    async getReceiveSettingsLocations(initOverrides?: RequestInit): Promise<GetLocationsResponse> {
        const response = await this.getReceiveSettingsLocationsRaw(initOverrides);
        return await response.value();
    }

    /**
     * プレスリリース種類一覧取得API
     * プレスリリース種類一覧取得API
     */
    async getReceiveSettingsPressReleaseTypesRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<GetPressReleaseTypesResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/receive_settings/press_release_types`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetPressReleaseTypesResponseFromJSON(jsonValue));
    }

    /**
     * プレスリリース種類一覧取得API
     * プレスリリース種類一覧取得API
     */
    async getReceiveSettingsPressReleaseTypes(initOverrides?: RequestInit): Promise<GetPressReleaseTypesResponse> {
        const response = await this.getReceiveSettingsPressReleaseTypesRaw(initOverrides);
        return await response.value();
    }

    /**
     * メディアユーザーにおすすめの企業を取得するAPI
     * ユーザーにおすすめの企業を取得するAPI
     */
    async getRecommendCompaniesRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<RecommendCompaniesResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/recommend_companies`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RecommendCompaniesResponseFromJSON(jsonValue));
    }

    /**
     * メディアユーザーにおすすめの企業を取得するAPI
     * ユーザーにおすすめの企業を取得するAPI
     */
    async getRecommendCompanies(initOverrides?: RequestInit): Promise<RecommendCompaniesResponse> {
        const response = await this.getRecommendCompaniesRaw(initOverrides);
        return await response.value();
    }

    /**
     * 最新順におすすめ一覧を取得する
     * おすすめ一覧プレスリリースを取得するAPI
     */
    async getRecommendPressReleasesRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<GetRecommendPressReleasesResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/me/recommend_press_releases`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetRecommendPressReleasesResponseFromJSON(jsonValue));
    }

    /**
     * 最新順におすすめ一覧を取得する
     * おすすめ一覧プレスリリースを取得するAPI
     */
    async getRecommendPressReleases(initOverrides?: RequestInit): Promise<GetRecommendPressReleasesResponse> {
        const response = await this.getRecommendPressReleasesRaw(initOverrides);
        return await response.value();
    }

    /**
     * Experimentsでのみ使用可能 指定したメディアユーザーのおすすめプレスリリースを取得する
     * 指定したメディアユーザーのおすすめプレスリリースを取得する
     */
    async getRecommendPressReleasesByMediaUserIdRaw(requestParameters: GetRecommendPressReleasesByMediaUserIdRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<GetRecommendPressReleasesResponse>> {
        if (requestParameters.mediaUserId === null || requestParameters.mediaUserId === undefined) {
            throw new runtime.RequiredError('mediaUserId','Required parameter requestParameters.mediaUserId was null or undefined when calling getRecommendPressReleasesByMediaUserId.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/media_user/{media_user_id}/recommend_press_releases`.replace(`{${"media_user_id"}}`, encodeURIComponent(String(requestParameters.mediaUserId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetRecommendPressReleasesResponseFromJSON(jsonValue));
    }

    /**
     * Experimentsでのみ使用可能 指定したメディアユーザーのおすすめプレスリリースを取得する
     * 指定したメディアユーザーのおすすめプレスリリースを取得する
     */
    async getRecommendPressReleasesByMediaUserId(requestParameters: GetRecommendPressReleasesByMediaUserIdRequest, initOverrides?: RequestInit): Promise<GetRecommendPressReleasesResponse> {
        const response = await this.getRecommendPressReleasesByMediaUserIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * エリアの一覧を取得
     * エリアの一覧を取得
     */
    async getRegionsRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<GetRegionsResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/regions`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetRegionsResponseFromJSON(jsonValue));
    }

    /**
     * エリアの一覧を取得
     * エリアの一覧を取得
     */
    async getRegions(initOverrides?: RequestInit): Promise<GetRegionsResponse> {
        const response = await this.getRegionsRaw(initOverrides);
        return await response.value();
    }

    /**
     * 検索ワードのサジェストを取得する
     * 検索ワードのサジェストを取得する
     */
    async getSearchAutocompleteRaw(requestParameters: GetSearchAutocompleteRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<GetSearchAutocompleteResponse>> {
        if (requestParameters.searchKeyword === null || requestParameters.searchKeyword === undefined) {
            throw new runtime.RequiredError('searchKeyword','Required parameter requestParameters.searchKeyword was null or undefined when calling getSearchAutocomplete.');
        }

        const queryParameters: any = {};

        if (requestParameters.searchKeyword !== undefined) {
            queryParameters['search_keyword'] = requestParameters.searchKeyword;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/search/autocomplete`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetSearchAutocompleteResponseFromJSON(jsonValue));
    }

    /**
     * 検索ワードのサジェストを取得する
     * 検索ワードのサジェストを取得する
     */
    async getSearchAutocomplete(requestParameters: GetSearchAutocompleteRequest, initOverrides?: RequestInit): Promise<GetSearchAutocompleteResponse> {
        const response = await this.getSearchAutocompleteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 最近の検索履歴を取得する
     * 最近の検索履歴を取得する
     */
    async getSearchRecentQueriesRaw(requestParameters: GetSearchRecentQueriesRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<GetSearchRecentQueriesResponse>> {
        const queryParameters: any = {};

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/search/recent_queries`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetSearchRecentQueriesResponseFromJSON(jsonValue));
    }

    /**
     * 最近の検索履歴を取得する
     * 最近の検索履歴を取得する
     */
    async getSearchRecentQueries(requestParameters: GetSearchRecentQueriesRequest = {}, initOverrides?: RequestInit): Promise<GetSearchRecentQueriesResponse> {
        const response = await this.getSearchRecentQueriesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 特定のチュートリアルの完了状態を確認するAPI
     * 特定のチュートリアルの完了状態を確認するAPI
     */
    async getTutorialRaw(requestParameters: GetTutorialRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<GetTutorialResponse>> {
        if (requestParameters.tutorialStep === null || requestParameters.tutorialStep === undefined) {
            throw new runtime.RequiredError('tutorialStep','Required parameter requestParameters.tutorialStep was null or undefined when calling getTutorial.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/tutorials/{tutorial_step}`.replace(`{${"tutorial_step"}}`, encodeURIComponent(String(requestParameters.tutorialStep))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetTutorialResponseFromJSON(jsonValue));
    }

    /**
     * 特定のチュートリアルの完了状態を確認するAPI
     * 特定のチュートリアルの完了状態を確認するAPI
     */
    async getTutorial(requestParameters: GetTutorialRequest, initOverrides?: RequestInit): Promise<GetTutorialResponse> {
        const response = await this.getTutorialRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * メディアユーザーアカウント設定API
     * メディアユーザーアカウント設定API
     */
    async postAccountSettingsRaw(requestParameters: PostAccountSettingsRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<MediaUserApiResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/account_settings`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PostAccountSettingsItemToJSON(requestParameters.postAccountSettingsItem),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MediaUserApiResponseFromJSON(jsonValue));
    }

    /**
     * メディアユーザーアカウント設定API
     * メディアユーザーアカウント設定API
     */
    async postAccountSettings(requestParameters: PostAccountSettingsRequest = {}, initOverrides?: RequestInit): Promise<MediaUserApiResponse> {
        const response = await this.postAccountSettingsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * メディアユーザーのメールアドレス変更API
     * メディアユーザーのメールアドレス変更API
     */
    async postAccountSettingsEmailRaw(requestParameters: PostAccountSettingsEmailRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<MediaUserApiResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/account_settings/email`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InlineObject1ToJSON(requestParameters.inlineObject1),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MediaUserApiResponseFromJSON(jsonValue));
    }

    /**
     * メディアユーザーのメールアドレス変更API
     * メディアユーザーのメールアドレス変更API
     */
    async postAccountSettingsEmail(requestParameters: PostAccountSettingsEmailRequest = {}, initOverrides?: RequestInit): Promise<MediaUserApiResponse> {
        const response = await this.postAccountSettingsEmailRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * (新UI用)メディアユーザーのメールアドレス変更 API V2
     * (新UI用)メディアユーザーのメールアドレス変更 API V2
     */
    async postAccountSettingsEmailV2Raw(requestParameters: PostAccountSettingsEmailV2OperationRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<MediaUserApiResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/v2/account_settings/email`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PostAccountSettingsEmailV2RequestToJSON(requestParameters.postAccountSettingsEmailV2Request),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MediaUserApiResponseFromJSON(jsonValue));
    }

    /**
     * (新UI用)メディアユーザーのメールアドレス変更 API V2
     * (新UI用)メディアユーザーのメールアドレス変更 API V2
     */
    async postAccountSettingsEmailV2(requestParameters: PostAccountSettingsEmailV2OperationRequest = {}, initOverrides?: RequestInit): Promise<MediaUserApiResponse> {
        const response = await this.postAccountSettingsEmailV2Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * メディアユーザーのパスワード変更API
     * メディアユーザーのパスワード変更API
     */
    async postAccountSettingsPasswordRaw(requestParameters: PostAccountSettingsPasswordRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<MediaUserApiResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/account_settings/password`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InlineObject2ToJSON(requestParameters.inlineObject2),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MediaUserApiResponseFromJSON(jsonValue));
    }

    /**
     * メディアユーザーのパスワード変更API
     * メディアユーザーのパスワード変更API
     */
    async postAccountSettingsPassword(requestParameters: PostAccountSettingsPasswordRequest = {}, initOverrides?: RequestInit): Promise<MediaUserApiResponse> {
        const response = await this.postAccountSettingsPasswordRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 初期設定を完了するAPI
     * 初期設定を完了するAPI
     */
    async postInitialSettingsCompletionRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<MediaUserApiResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/initial_settings_completion`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MediaUserApiResponseFromJSON(jsonValue));
    }

    /**
     * 初期設定を完了するAPI
     * 初期設定を完了するAPI
     */
    async postInitialSettingsCompletion(initOverrides?: RequestInit): Promise<MediaUserApiResponse> {
        const response = await this.postInitialSettingsCompletionRaw(initOverrides);
        return await response.value();
    }

    /**
     * メディアユーザーから退会する
     * メディアユーザーから退会する
     */
    async postLeaveRaw(requestParameters: PostLeaveRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<MediaUserApiResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/leave`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: LeaveRequestBodyToJSON(requestParameters.leaveRequestBody),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MediaUserApiResponseFromJSON(jsonValue));
    }

    /**
     * メディアユーザーから退会する
     * メディアユーザーから退会する
     */
    async postLeave(requestParameters: PostLeaveRequest = {}, initOverrides?: RequestInit): Promise<MediaUserApiResponse> {
        const response = await this.postLeaveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 検索条件を保存するAPI
     * 検索条件を保存するAPI
     */
    async postMeSearchConditionRaw(requestParameters: PostMeSearchConditionRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<MediaUserApiResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/me/search_conditions`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PostSearchConditionToJSON(requestParameters.postSearchCondition),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MediaUserApiResponseFromJSON(jsonValue));
    }

    /**
     * 検索条件を保存するAPI
     * 検索条件を保存するAPI
     */
    async postMeSearchCondition(requestParameters: PostMeSearchConditionRequest = {}, initOverrides?: RequestInit): Promise<MediaUserApiResponse> {
        const response = await this.postMeSearchConditionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 受信設定の内容を一括で更新する
     * 受信設定の内容を一括で更新する
     */
    async postReceiveSettingsBulkUpdateRaw(requestParameters: PostReceiveSettingsBulkUpdateRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<MediaUserApiResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/receive_settings/bulk_update`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ReceiveSettingsBulkUpdatePostRequestToJSON(requestParameters.receiveSettingsBulkUpdatePostRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MediaUserApiResponseFromJSON(jsonValue));
    }

    /**
     * 受信設定の内容を一括で更新する
     * 受信設定の内容を一括で更新する
     */
    async postReceiveSettingsBulkUpdate(requestParameters: PostReceiveSettingsBulkUpdateRequest = {}, initOverrides?: RequestInit): Promise<MediaUserApiResponse> {
        const response = await this.postReceiveSettingsBulkUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 特定のビジネスカテゴリの受信設定を追加するAPI
     * 特定のビジネスカテゴリの受信設定を追加するAPI
     */
    async postReceiveSettingsBusinessCategoriesRaw(requestParameters: PostReceiveSettingsBusinessCategoriesRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<MediaUserApiResponse>> {
        if (requestParameters.categoryId === null || requestParameters.categoryId === undefined) {
            throw new runtime.RequiredError('categoryId','Required parameter requestParameters.categoryId was null or undefined when calling postReceiveSettingsBusinessCategories.');
        }

        if (requestParameters.categoryLv2Id === null || requestParameters.categoryLv2Id === undefined) {
            throw new runtime.RequiredError('categoryLv2Id','Required parameter requestParameters.categoryLv2Id was null or undefined when calling postReceiveSettingsBusinessCategories.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/receive_settings/business_categories/{category_id}/{category_lv2_id}`.replace(`{${"category_id"}}`, encodeURIComponent(String(requestParameters.categoryId))).replace(`{${"category_lv2_id"}}`, encodeURIComponent(String(requestParameters.categoryLv2Id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MediaUserApiResponseFromJSON(jsonValue));
    }

    /**
     * 特定のビジネスカテゴリの受信設定を追加するAPI
     * 特定のビジネスカテゴリの受信設定を追加するAPI
     */
    async postReceiveSettingsBusinessCategories(requestParameters: PostReceiveSettingsBusinessCategoriesRequest, initOverrides?: RequestInit): Promise<MediaUserApiResponse> {
        const response = await this.postReceiveSettingsBusinessCategoriesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 特定の市区町村の受信設定を追加するAPI
     * 特定の市区町村の受信設定を追加するAPI
     */
    async postReceiveSettingsCitiesRaw(requestParameters: PostReceiveSettingsCitiesRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<MediaUserApiResponse>> {
        if (requestParameters.prefectureId === null || requestParameters.prefectureId === undefined) {
            throw new runtime.RequiredError('prefectureId','Required parameter requestParameters.prefectureId was null or undefined when calling postReceiveSettingsCities.');
        }

        if (requestParameters.cityId === null || requestParameters.cityId === undefined) {
            throw new runtime.RequiredError('cityId','Required parameter requestParameters.cityId was null or undefined when calling postReceiveSettingsCities.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/receive_settings/locations/{prefecture_id}/{city_id}`.replace(`{${"prefecture_id"}}`, encodeURIComponent(String(requestParameters.prefectureId))).replace(`{${"city_id"}}`, encodeURIComponent(String(requestParameters.cityId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MediaUserApiResponseFromJSON(jsonValue));
    }

    /**
     * 特定の市区町村の受信設定を追加するAPI
     * 特定の市区町村の受信設定を追加するAPI
     */
    async postReceiveSettingsCities(requestParameters: PostReceiveSettingsCitiesRequest, initOverrides?: RequestInit): Promise<MediaUserApiResponse> {
        const response = await this.postReceiveSettingsCitiesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 特定の企業カテゴリの受信設定を追加するAPI
     * 特定の企業カテゴリの受信設定を追加するAPI
     */
    async postReceiveSettingsCompanyCategoriesRaw(requestParameters: PostReceiveSettingsCompanyCategoriesRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<MediaUserApiResponse>> {
        if (requestParameters.categoryId === null || requestParameters.categoryId === undefined) {
            throw new runtime.RequiredError('categoryId','Required parameter requestParameters.categoryId was null or undefined when calling postReceiveSettingsCompanyCategories.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/receive_settings/company_categories/{category_id}`.replace(`{${"category_id"}}`, encodeURIComponent(String(requestParameters.categoryId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MediaUserApiResponseFromJSON(jsonValue));
    }

    /**
     * 特定の企業カテゴリの受信設定を追加するAPI
     * 特定の企業カテゴリの受信設定を追加するAPI
     */
    async postReceiveSettingsCompanyCategories(requestParameters: PostReceiveSettingsCompanyCategoriesRequest, initOverrides?: RequestInit): Promise<MediaUserApiResponse> {
        const response = await this.postReceiveSettingsCompanyCategoriesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 特定のキーワードの受信設定を追加するAPI
     * 特定のキーワードの受信設定を追加するAPI
     */
    async postReceiveSettingsKeywordsRaw(requestParameters: PostReceiveSettingsKeywordsRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<PostReceiveSettingsKeywordsResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/receive_settings/keywords`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InlineObjectToJSON(requestParameters.inlineObject),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PostReceiveSettingsKeywordsResponseFromJSON(jsonValue));
    }

    /**
     * 特定のキーワードの受信設定を追加するAPI
     * 特定のキーワードの受信設定を追加するAPI
     */
    async postReceiveSettingsKeywords(requestParameters: PostReceiveSettingsKeywordsRequest = {}, initOverrides?: RequestInit): Promise<PostReceiveSettingsKeywordsResponse> {
        const response = await this.postReceiveSettingsKeywordsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 特定の都道府県の受信設定を追加するAPI
     * 特定の都道府県の受信設定を追加するAPI
     */
    async postReceiveSettingsPrefecturesRaw(requestParameters: PostReceiveSettingsPrefecturesRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<MediaUserApiResponse>> {
        if (requestParameters.prefectureId === null || requestParameters.prefectureId === undefined) {
            throw new runtime.RequiredError('prefectureId','Required parameter requestParameters.prefectureId was null or undefined when calling postReceiveSettingsPrefectures.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/receive_settings/locations/{prefecture_id}`.replace(`{${"prefecture_id"}}`, encodeURIComponent(String(requestParameters.prefectureId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MediaUserApiResponseFromJSON(jsonValue));
    }

    /**
     * 特定の都道府県の受信設定を追加するAPI
     * 特定の都道府県の受信設定を追加するAPI
     */
    async postReceiveSettingsPrefectures(requestParameters: PostReceiveSettingsPrefecturesRequest, initOverrides?: RequestInit): Promise<MediaUserApiResponse> {
        const response = await this.postReceiveSettingsPrefecturesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 特定のプレスリリース種類の受信設定を追加するAPI
     * 特定のプレスリリース種類の受信設定を追加するAPI
     */
    async postReceiveSettingsPressReleaseTypesRaw(requestParameters: PostReceiveSettingsPressReleaseTypesRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<MediaUserApiResponse>> {
        if (requestParameters.typeId === null || requestParameters.typeId === undefined) {
            throw new runtime.RequiredError('typeId','Required parameter requestParameters.typeId was null or undefined when calling postReceiveSettingsPressReleaseTypes.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/receive_settings/press_release_types/{type_id}`.replace(`{${"type_id"}}`, encodeURIComponent(String(requestParameters.typeId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MediaUserApiResponseFromJSON(jsonValue));
    }

    /**
     * 特定のプレスリリース種類の受信設定を追加するAPI
     * 特定のプレスリリース種類の受信設定を追加するAPI
     */
    async postReceiveSettingsPressReleaseTypes(requestParameters: PostReceiveSettingsPressReleaseTypesRequest, initOverrides?: RequestInit): Promise<MediaUserApiResponse> {
        const response = await this.postReceiveSettingsPressReleaseTypesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 最近の検索履歴を保存する
     * 最近の検索履歴を保存する
     */
    async postSearchRecentQueriesRaw(requestParameters: PostSearchRecentQueriesOperationRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<MediaUserApiResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/search/recent_queries`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PostSearchRecentQueriesRequestToJSON(requestParameters.postSearchRecentQueriesRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MediaUserApiResponseFromJSON(jsonValue));
    }

    /**
     * 最近の検索履歴を保存する
     * 最近の検索履歴を保存する
     */
    async postSearchRecentQueries(requestParameters: PostSearchRecentQueriesOperationRequest = {}, initOverrides?: RequestInit): Promise<MediaUserApiResponse> {
        const response = await this.postSearchRecentQueriesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * メディアユーザーのサインイン
     * メディアユーザーのサインイン
     */
    async postSignInRaw(requestParameters: PostSignInRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<SignInApiResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/sign_in`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SignInRequestBodyToJSON(requestParameters.signInRequestBody),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SignInApiResponseFromJSON(jsonValue));
    }

    /**
     * メディアユーザーのサインイン
     * メディアユーザーのサインイン
     */
    async postSignIn(requestParameters: PostSignInRequest = {}, initOverrides?: RequestInit): Promise<SignInApiResponse> {
        const response = await this.postSignInRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 企業を検索する
     * 企業を検索する
     */
    async searchCompaniesRaw(requestParameters: SearchCompaniesRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<SearchedCompaniesResponse>> {
        if (requestParameters.keyword === null || requestParameters.keyword === undefined) {
            throw new runtime.RequiredError('keyword','Required parameter requestParameters.keyword was null or undefined when calling searchCompanies.');
        }

        const queryParameters: any = {};

        if (requestParameters.keyword !== undefined) {
            queryParameters['keyword'] = requestParameters.keyword;
        }

        if (requestParameters.cursor !== undefined) {
            queryParameters['cursor'] = requestParameters.cursor;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/companies/search`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SearchedCompaniesResponseFromJSON(jsonValue));
    }

    /**
     * 企業を検索する
     * 企業を検索する
     */
    async searchCompanies(requestParameters: SearchCompaniesRequest, initOverrides?: RequestInit): Promise<SearchedCompaniesResponse> {
        const response = await this.searchCompaniesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ログインしているユーザーがフォローしている企業、ビジネスカテゴリを取得するAPI
     * Search press releases from companies and business_categories you follow
     */
    async searchFollowingPressReleasesRaw(requestParameters: SearchFollowingPressReleasesRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<SearchFollowingPressReleaseResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/me/following/press_releases/search`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SearchFollowingPressReleaseRequestToJSON(requestParameters.searchFollowingPressReleaseRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SearchFollowingPressReleaseResponseFromJSON(jsonValue));
    }

    /**
     * ログインしているユーザーがフォローしている企業、ビジネスカテゴリを取得するAPI
     * Search press releases from companies and business_categories you follow
     */
    async searchFollowingPressReleases(requestParameters: SearchFollowingPressReleasesRequest = {}, initOverrides?: RequestInit): Promise<SearchFollowingPressReleaseResponse> {
        const response = await this.searchFollowingPressReleasesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * メディアユーザーの最新プレスリリースを取得するAPI。 新UI上で、絞り込み用のパラメーターが追加されるため、GETでリクエストを送るとURLが長くなってしまう。それを避けるために、POSTでリクエストを送るようにする。
     * 最新プレスリリースを取得するAPI（新UI用）
     */
    async searchLatestPressReleasesRaw(requestParameters: SearchLatestPressReleasesOperationRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<SearchLatestPressReleasesResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/press_releases`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SearchLatestPressReleasesRequestToJSON(requestParameters.searchLatestPressReleasesRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SearchLatestPressReleasesResponseFromJSON(jsonValue));
    }

    /**
     * メディアユーザーの最新プレスリリースを取得するAPI。 新UI上で、絞り込み用のパラメーターが追加されるため、GETでリクエストを送るとURLが長くなってしまう。それを避けるために、POSTでリクエストを送るようにする。
     * 最新プレスリリースを取得するAPI（新UI用）
     */
    async searchLatestPressReleases(requestParameters: SearchLatestPressReleasesOperationRequest = {}, initOverrides?: RequestInit): Promise<SearchLatestPressReleasesResponse> {
        const response = await this.searchLatestPressReleasesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 最新順にビジネスカテゴリに紐づくプレスリリースを取得する
     * ビジネスカテゴリに紐づくプレスリリースを取得するAPI
     */
    async searchLatestPressReleasesByBusinessCategoryLv2IdRaw(requestParameters: SearchLatestPressReleasesByBusinessCategoryLv2IdOperationRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<SearchLatestPressReleasesByBusinessCategoryLv2IdResponse>> {
        if (requestParameters.businessCategoryLv2Id === null || requestParameters.businessCategoryLv2Id === undefined) {
            throw new runtime.RequiredError('businessCategoryLv2Id','Required parameter requestParameters.businessCategoryLv2Id was null or undefined when calling searchLatestPressReleasesByBusinessCategoryLv2Id.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/business_categories_lv2/{business_category_lv2_id}/latest_press_releases`.replace(`{${"business_category_lv2_id"}}`, encodeURIComponent(String(requestParameters.businessCategoryLv2Id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SearchLatestPressReleasesByBusinessCategoryLv2IdRequestToJSON(requestParameters.searchLatestPressReleasesByBusinessCategoryLv2IdRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SearchLatestPressReleasesByBusinessCategoryLv2IdResponseFromJSON(jsonValue));
    }

    /**
     * 最新順にビジネスカテゴリに紐づくプレスリリースを取得する
     * ビジネスカテゴリに紐づくプレスリリースを取得するAPI
     */
    async searchLatestPressReleasesByBusinessCategoryLv2Id(requestParameters: SearchLatestPressReleasesByBusinessCategoryLv2IdOperationRequest, initOverrides?: RequestInit): Promise<SearchLatestPressReleasesByBusinessCategoryLv2IdResponse> {
        const response = await this.searchLatestPressReleasesByBusinessCategoryLv2IdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * プレスリリースを検索する
     * プレスリリースを検索する
     */
    async searchPressReleasesRaw(requestParameters: SearchPressReleasesRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<SearchedPressReleasesResponse>> {
        if (requestParameters.keyword === null || requestParameters.keyword === undefined) {
            throw new runtime.RequiredError('keyword','Required parameter requestParameters.keyword was null or undefined when calling searchPressReleases.');
        }

        const queryParameters: any = {};

        if (requestParameters.keyword !== undefined) {
            queryParameters['keyword'] = requestParameters.keyword;
        }

        if (requestParameters.cursor !== undefined) {
            queryParameters['cursor'] = requestParameters.cursor;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/press_releases/search`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SearchedPressReleasesResponseFromJSON(jsonValue));
    }

    /**
     * プレスリリースを検索する
     * プレスリリースを検索する
     */
    async searchPressReleases(requestParameters: SearchPressReleasesRequest, initOverrides?: RequestInit): Promise<SearchedPressReleasesResponse> {
        const response = await this.searchPressReleasesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * プレスリリースを公開日時順に検索するAPI
     * Search press releases order by published date
     */
    async searchPressReleasesOrderByPublishedDateRaw(requestParameters: SearchPressReleasesOrderByPublishedDateRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<SearchPublishedDateOrderPressReleaseResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/press_releases/search/published_date_order`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SearchPublishedDateOrderPressReleaseRequestToJSON(requestParameters.searchPublishedDateOrderPressReleaseRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SearchPublishedDateOrderPressReleaseResponseFromJSON(jsonValue));
    }

    /**
     * プレスリリースを公開日時順に検索するAPI
     * Search press releases order by published date
     */
    async searchPressReleasesOrderByPublishedDate(requestParameters: SearchPressReleasesOrderByPublishedDateRequest = {}, initOverrides?: RequestInit): Promise<SearchPublishedDateOrderPressReleaseResponse> {
        const response = await this.searchPressReleasesOrderByPublishedDateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * プレスリリースを公開日時順に検索するAPI
     * Search press releases order by relevance score
     */
    async searchPressReleasesOrderByRelevanceScoreRaw(requestParameters: SearchPressReleasesOrderByRelevanceScoreRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<SearchRelevanceScoreOrderPressReleaseResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/press_releases/search/relevance_order`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SearchRelevanceScoreOrderPressReleaseRequestToJSON(requestParameters.searchRelevanceScoreOrderPressReleaseRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SearchRelevanceScoreOrderPressReleaseResponseFromJSON(jsonValue));
    }

    /**
     * プレスリリースを公開日時順に検索するAPI
     * Search press releases order by relevance score
     */
    async searchPressReleasesOrderByRelevanceScore(requestParameters: SearchPressReleasesOrderByRelevanceScoreRequest = {}, initOverrides?: RequestInit): Promise<SearchRelevanceScoreOrderPressReleaseResponse> {
        const response = await this.searchPressReleasesOrderByRelevanceScoreRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 指定されたプレスリリースの保存（ブックマーク）を解除する
     * プレスリリースの保存を解除
     */
    async unbookmarkPressReleaseRaw(requestParameters: UnbookmarkPressReleaseRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<MediaUserApiResponse>> {
        if (requestParameters.pressReleaseId === null || requestParameters.pressReleaseId === undefined) {
            throw new runtime.RequiredError('pressReleaseId','Required parameter requestParameters.pressReleaseId was null or undefined when calling unbookmarkPressRelease.');
        }

        if (requestParameters.companyId === null || requestParameters.companyId === undefined) {
            throw new runtime.RequiredError('companyId','Required parameter requestParameters.companyId was null or undefined when calling unbookmarkPressRelease.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/press_releases/{press_release_id}.{company_id}/bookmark`.replace(`{${"press_release_id"}}`, encodeURIComponent(String(requestParameters.pressReleaseId))).replace(`{${"company_id"}}`, encodeURIComponent(String(requestParameters.companyId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MediaUserApiResponseFromJSON(jsonValue));
    }

    /**
     * 指定されたプレスリリースの保存（ブックマーク）を解除する
     * プレスリリースの保存を解除
     */
    async unbookmarkPressRelease(requestParameters: UnbookmarkPressReleaseRequest, initOverrides?: RequestInit): Promise<MediaUserApiResponse> {
        const response = await this.unbookmarkPressReleaseRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
